import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  footerCodeConstDefault,
  footerCodeConstHome,
  footerCodeConstAbout,
  footerCodeConstCompare,
  footerCodeConstCriticalIllness,
  footerCodeConstSelectTerm,
  footerCodeConstIndexaUniverse,
  footerCodeConstUniverseLife,
  footerCodeConstCreditedInterestRate,
  footerCodeConstTerms,
  footerCodeConstPrivacy,
  footerCodeConstSecure,
} from "../constants/FooterCodeConst";
import { LanguageContext } from "../Hooks/langugaeContext.js";

const TermsCondition = () => {
  const location = useLocation();
  const { language, toggleLanguage } = useContext(LanguageContext);

  const [footTitle, setFootTitle] = useState("Footnotes");
  const [footTitleLink, setFootTitleLink] = useState(true);
  const [esbCode, setEsbCode] = useState("ESB-9737-1125");
  const [footerCode, setFooterCode] = useState(
    footerCodeConstDefault[language],
  );
  console.log("language", language, footerCodeConstDefault[language]);
  useEffect(() => {
    if (location.pathname === "/") {
      setFooterCode(footerCodeConstHome[language]);
    } else if (location.pathname === "/about") {
      setFooterCode(footerCodeConstAbout[language]);
    } else if (location.pathname === "/compare-plans") {
      setFooterCode(footerCodeConstCompare[language]);
    } else if (location.pathname === "/universal-life-insurance") {
      setFooterCode(footerCodeConstUniverseLife[language]);
    } else if (location.pathname === "/indexed-universal-life-insurance") {
      setFooterCode(footerCodeConstIndexaUniverse[language]);
    } else if (location.pathname === "/term-life-insurance") {
      setFooterCode(footerCodeConstSelectTerm[language]);
    } else if (location.pathname === "/critical-illness-insurance") {
      setFooterCode(footerCodeConstCriticalIllness[language]);
    } else if (location.pathname === "/faqs") {
      setEsbCode("ESB-9703");
      setFooterCode(footerCodeConstDefault[language]);
    } else if (location.pathname === "/terms") {
      setFooterCode(footerCodeConstTerms[language]);
    } else if (location.pathname === "/secure") {
      setFooterCode(footerCodeConstSecure[language]);
    } else if (location.pathname === "/privacy") {
      setFooterCode(footerCodeConstPrivacy[language]);
    } else if (location.pathname === "/credited-interest-rate") {
      setFooterCode(footerCodeConstCreditedInterestRate[language]);
    } else {
      setEsbCode("");
      setFooterCode(footerCodeConstDefault[language]);
    }
  }, [location.pathname, language]);

  return (
    <div className="container termsmaindiv bg-[#FAFAFA] pt-8 lg:pb-28 pb-12">
      <span
        className="block mb-0 lg:p-0 px-4"
        dangerouslySetInnerHTML={{ __html: footerCode }}
      ></span>
    </div>
  );
};

export default TermsCondition;
